import {SceneJsonImporter} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/io/json/import/Scene';
import {PolyScene} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/scene/PolyScene';

// import {EngineExtendedAllRegister} from './registers';
// EngineExtendedAllRegister.run();

import {EngineMiniAllRegister} from './registers_mini';
EngineMiniAllRegister.run();

export {PolyScene, SceneJsonImporter};

import {addOnDocumentLoadScene} from './index_common';
addOnDocumentLoadScene();
